import { useMutation } from '@tanstack/react-query';
import type { CandidateBoardPostRequest } from '../types/CandidateBoard';

export default function usePostCandidateBoard() {
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement).content;
  return useMutation({
    mutationFn: async ({
      title,
      divide_status,
      color_type,
      order_number,
    }: CandidateBoardPostRequest) => {
      const response = await fetch(`/agent/api/candidate_boards`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-CSRF-Token': token,
        },
        body: JSON.stringify({
          title,
          divide_status,
          color_type,
          order_number,
        }),
      });
      const data = await response.json();
      return data;
    },
  });
}
